import { cn } from '@/utilities/ui'

interface Props {
  margin?: number
  children: React.ReactNode
  className?: string
}

export function OverflowNegativeMargin({ children, className, margin = 10 }: Props) {
  return (
    <div
      className={cn('overflow-hidden', className)}
      style={{
        margin: `-${margin}px`,
        width: `calc(100% + ${margin * 2}px)`,
        height: `calc(100% + ${margin * 2}px)`,
      }}
    >
      <div className="w-full h-full" style={{ padding: `${margin}px` }}>
        {children}
      </div>
    </div>
  )
}
